module.exports = __webpack_public_path__ + "img/photo_crm.f219fb8c.png";